<script>
    import Router from 'svelte-spa-router'
    import Home from '../routes/Home.svelte';
  import Todo from '../routes/Todo.svelte';
  import View from '../routes/View.svelte'
  import Accessibility from '../routes/Accessibiliity.svelte'
  import Contact from '../routes/Contact.svelte';
  import Book from '../routes/Book.svelte';
    let isMenuOpen = false; // State variable to track menu open/close
  
    function toggleMenu() {
      isMenuOpen = !isMenuOpen;
    }
    function closeMenu() {
      isMenuOpen = false;
    }

    const routes = {
    
    '/': Home,
    '/View': View,
    '/Accessibility': Accessibility,
    '/Contact':Contact,
    '/Book':Book,
    '/Todo': Todo,
    '*': Home
  }
  </script>
  
  <main>
   
    <button class="hamburger" on:click={toggleMenu}>
      <span class="bar" />
      <span class="bar" />
      <span class="bar" />
      
    </button>
  
   




    {#if isMenuOpen}
      <div class="mobile-menu active">
        <ul>
          <li >
            <a href="#/Home" on:click={closeMenu}>Home</a>
          </li>
          <li>
            <a href="#/view" on:click={closeMenu}>View</a>
          </li>
          <li>
            <a href="#/book" on:click={closeMenu}>Book</a>
          </li>
          <li>
            <a href="#/accessibility" on:click={closeMenu}>Accessibilty</a>
          </li>
          <li>
            <a href="#/contact" on:click={closeMenu}>Contact</a>
          </li>
          <li>
            <a href="#/todo" on:click={closeMenu}>To do</a>
          </li>
        </ul>
      </div>
    {/if}
  </main>
  
  <style>
      main{
        background: white;
      width: 104vw;
      margin-left: -11px;
      position: fixed;
      top: 0px;
      z-index: 20;
      
      }
    .hamburger {
      /* Style your hamburger button */
      display: block;
      cursor: pointer;
      position: -webkit-sticky; /* For Safari */
      position:relative;
      
      z-index: 10;
      top: 4px;
      left: 3%;
      background-color: #ffffff;
    }
  
    .bar {
      /* Style your hamburger bars */
      display: block;
      width: 50px;
      height: 2px;
      margin: 7px auto;
      background-color: #1476D1;
      transition: 0.4s; /* Add transition for smooth animation */
      z-index: 10;
    }
  
    .mobile-menu {
      /* Style your mobile menu */
      position: absolute;
      top: -60px;
      left: 0;
      width: 100%;
      background-color: #ffffffc7;
      box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
      transition: transform 0.3s ease-in-out;
      transform: translateX(-100%); /* Initially hide the menu off-screen */
   
    }
  .mobile-menu li{
      list-style: none;
      margin-bottom: 20px;
      
  }
  .mobile-menu li a{
      text-decoration: none;
      font-size:xx-large;
      color: #1476D1;
     
  }
  .mobile-menu li a:hover{
      text-decoration:underline;
      font-size:xx-large;
      color: #4191dc;
     
  }
    /* Slide-in animation for the menu */
    .mobile-menu.active {
      transform: translateX(0vw);
      transform: translateY(15vh);
     height: 100vh;
    }
    @media screen and (min-width: 800px) {
      .hamburger {
        display: none;
      }
    }
  </style>
  